(function($) {

	var getLocation = function(href) {
	    var l = document.createElement("a");
	    l.href = href;
	    return l;
	};

	$(document).on('click', 'a', function(event) {
		var href = window.location.href;
		var l = getLocation( href );
		var currentSite = l.hostname;

		href = $(this).attr("href");
		l = getLocation( href );
		var targetSite = l.hostname;

		// Fix IE11 thinks internal links are external
		if ( !href.match(/^https?:\/\//) ) {
			return;
		}

		if ( $(this).hasClass('noexitnotice') || $(this).is('[data-featherlight]') ) {
			return;
		}

		var gaCategory = $(this).data('ga-category');
		var gaAction   = $(this).data('ga-action');
		var gaLabel = $(this).data('ga-label');

		if ( currentSite !== targetSite ) {

			event.preventDefault();

			var template = _.template( ESRB.exit_notice_message );
			var message = template({
				currentSite: currentSite,
				targetSite:  targetSite
			});

			if( ESRB.spanish ) {
				var cancel = 'Cancelar';
				var proceed = 'Continuar';
			} else {
				var cancel = 'Cancel';
				var proceed = 'Proceed';
			}

			template = _.template( '<div class="fullscreen-notice" id="exit_notice">'+
			'<div class="overlay"></div>'+
			'<div class="window">'+
				'<a href="#" class="close"></a>'+
				'<div class="heading"></div>'+
				'<div class="content">'+
					'<div class="title"><%= exitNoticeTitle %></div>'+
					'<div class="message"><%= exitNoticeMessage %></div>'+
				'</div>'+
				'<div class="buttons">'+
					'<a href="#" class="button cancel">' + cancel + '</a>'+
					'<a href="#" class="button button-primary submit" data-url="<%= targetUrl %>">' + proceed + '</a>'+
				'</div>'+
			'</div>'+
			'</div>' );

			var html = template({
				exitNoticeTitle: ESRB.exit_notice_title,
				exitNoticeMessage:  message,
				targetUrl: href
			});

			var fsWindow = $(html);

			fsWindow.find('.window').hide();
			fsWindow.hide();

			fsWindow.appendTo('body');

			fsWindow.fadeIn(500, function() {
				fsWindow.find('.window').fadeIn(500);
			});

			fsWindow.on('click', '.cancel, .close', function(event) {
				event.preventDefault();
				fsWindow.find('.window').fadeOut(500, function() {
					fsWindow.fadeOut('500', function() {
						fsWindow.remove();
					});
				});
			});

			fsWindow.on('click', '.submit', function(event) {
				event.preventDefault();

				if ( gaCategory && gaAction && typeof ga !== 'undefined' ) {
					ga( 'send', 'event', gaCategory, gaAction, gaLabel );
				}

				var path = $(this).data('url');
				document.location.href = path;
			});
		}
	});
	
})(jQuery);